import { Component, OnInit, Input } from '@angular/core';
import { CandidateStore } from '../../../dashboards/store/candidate-store';
import { Experience } from '../../../shared/models/experience';

@Component({
  selector: 'app-experience-preview',
  templateUrl: './experience-preview.component.html',
  styleUrls: ['./experience-preview.component.scss']
})
export class ExperiencePreviewComponent implements OnInit {
  @Input() experience: Experience;
  @Input() index: number;
  @Input() readonly: boolean;

  showEditForm: boolean = false;

  constructor(private dashboardState: CandidateStore) {
    this.dashboardState.experiences.subscribe(exp => {
      if (!exp || !this.experience) {
        return;
      }

      const foundIndex = exp.indexOf(this.experience);
      this.index = foundIndex;
    });
  }

  ngOnInit() {
  }

  editExperience(): void {
    if (this.showEditForm) {
      this.showEditForm = false;
    } else {
      this.showEditForm = true;
    }
  }

  deleteExperience(): void {
    this.dashboardState.removeExperience(this.index);
  }

  experienceSaved(): void {
    this.showEditForm = false;
  }

}
